<template>
  <b-modal v-model="isShow" size="lg" title="Modal with Popover" v-b-modal.modal-scrollable>
    <template #modal-header="{ close }">
      <h5>{{ dataRequest.id ? 'Edit Contact' : 'Add Contact' }}</h5>
      <!-- <b-button size="sm" variant="outline-danger" @click="cancel()">
        Close Modal
      </b-button> -->
    </template>

    <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
      <form @submit.prevent="handleSubmit(save)">
        <div class="card p-10 pt-15" style="overflow-x: hidden; overflow-y: auto">
          <div class="card-body px-20 row">
            <div class="col-md-12">
              <ValidationProvider rules="required" vid="contractCode" name="Mã hợp đồng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Mã hợp đồng<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <!-- <Select2 :disabled="!!dataRequest.ticketId && dataRequest.status != 'NEW'"
                      v-model="dataRequest.mcLocationBizId" :options="optionsBizAddress" /> -->
                    <input type="text" class="form-control" v-model="dataRequest.contractCode" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="ownerName" name="Tên">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Tên<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control" v-model="dataRequest.ownerName" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>

    <template #modal-footer>
      <b-button type="reset" variant="outline-danger" @click="cancel">
        <b-icon icon="x-lg" aria-hidden="true" />
          Huỷ
      </b-button>
      <b-button type="submit" variant="outline-primary" @click="save">
        <b-icon icon="check-lg" aria-hidden="true" /> OK
      </b-button>
    </template>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true">
    </VueLoadingOverlay>
  </b-modal>
</template>

<script>

import { Create, Update } from '@/services/customer-support/contract'
import cloneDeep from "lodash/cloneDeep";


export default {
  // components: {
  // },
  // props: {
  //   isShowBtnAdd: {
  //     type: Boolean,
  //     default: true,
  //   },
  // },
  async created() {

  },

  data() {
    return {
      isShow: false,
      dataRequest: {},
      showLoading: false,
    }
  },

  methods: {
    async save() {
      if (!this.validateForm()) return;

      if (this.dataRequest.id) {
        await this.edit();
      }
      if (!this.dataRequest.id) {
        await this.create();
      }
    },

    async create() {
      try {
        this.showLoading = true;

        const params = cloneDeep(this.dataRequest);
        const res = await Create(params);
        if(res && res.code == 1000){
          this.showSuccessMx(res.message);
          this.isShow = false;
          this.$emit('fetchData');
        }

      } catch (e) {
        this.showFailMx(e.message);
      } finally {
        this.showLoading = false;
      }
    },

    async edit() {
      try {
        this.showLoading = true;

        const params = cloneDeep(this.dataRequest);
        const res = await Update(params.id,params);
        if(res && res.code == 1000){
          this.showSuccessMx(res.message);
          this.isShow = false;
          this.$emit('fetchData');
        }

      } catch (e) {
        this.showFailMx(e.message);
      } finally {
        this.showLoading = false;
      }
    },

    validateForm() {
      const isValid = this.$refs.observer.validate();
      if (isValid) {
        return true;
      }

    },

    show(info) {
      this.isShow = true;
      this.dataRequest = {};
      this.$nextTick(() => {
        this.$refs.observer.reset();
        if (info) {
          this.dataRequest = info;
        }
      });
    },

    cancel() {
      this.isShow = false;
    }
  }
}
</script>

<style scoped></style>